import { rlAxisData, rlAxisArcData } from "@/rlMxModules/rlDataClass/index";
import store from "@/store/index";
import * as THREE from "three";
import {
  areLineCollinear,
  addEntityToDrawing,
  getEntityData,
  ptOnArc,
} from "@/rlMxModules/operate/operateApi";

import {
  getrlStdFlr,
  delBulkRlStdFlrFieldDatas,
  updateBulkRlStdFlrFieldDatas,
} from "@/mixins/LiteModuleDb.js";
import { generate_guid } from "@/rlMxModules/utils/util";
import {
  calculateArcAngle,
  normalizeAngle,
  toDegrees,
} from "@/rlMxModules/operate/GraphicDataCal.js";

import { saveRlData } from "@/mixins/LiteModuleDb.js";
import { getIdbTime } from "@/utils/indexedDBModule/saveAllModules.js";
var iUpdateAxisTimer;
//更新当前画布的轴线数据--updateAllFloor:是否更新所有楼层的轴线和网格数据
export const updateAxisData = async (
  updateAllFloor = false,
  forceUpdata = false
) => {
  //若没有变更，不需要重新计算
  if (!forceUpdata && iUpdateAxisTimer !== undefined) {
    const { value, timestamp } = await saveRlData();
    if ((timestamp - iUpdateAxisTimer) / 1000 < 3) {
      return;
    }
  }

  let floorGuids = [];
  if (updateAllFloor) {
    //获取所有楼层的Guid
    for (
      let index = 0;
      index < store.state.globalData.rl_floor_arr.length;
      index++
    ) {
      const floor = store.state.globalData.rl_floor_arr[index];
      floorGuids.push(floor.StdFlrGuid);
    }
  } else {
    floorGuids = [store.state.globalData.rl_stdFlr_id];
  }

  const getEquleAxisData = (currAxisDatas, jointDatas, pt1, pt2) => {
    for (const key in currAxisDatas) {
      let axis = currAxisDatas[key];
      if (axis.IsMainAxis < 0) continue;
      // if (axis.Name == "") continue; //没有命名则不用考虑

      const joint_1 = jointDatas[axis.Jt1Guid];
      const joint_2 = jointDatas[axis.Jt2Guid];
      if (!joint_1 || !joint_2) {
        continue;
      }
      let itemPt1 = new THREE.Vector3(joint_1.X, joint_1.Y, 0);
      let itemPt2 = new THREE.Vector3(joint_2.X, joint_2.Y, 0);
      if (areLineCollinear(itemPt1, itemPt2, pt1, pt2)) {
        return axis;
      }
    }
    return null;
  };

  const getEquleArcAxisData = (currAxisDatas, jointDatas, ptCenter, pt2) => {
    let redius = ptCenter.distanceTo(pt2);
    for (const key in currAxisDatas) {
      let axis = currAxisDatas[key];
      if (axis.IsMainAxis >= 0) continue;
      // if (axis.Name == "") continue; //没有命名则不用考虑
      if (axis.IsMainAxis >= 0) continue; //不是弧形轴线

      const joint_1 = jointDatas[axis.Jt1Guid];
      const joint_2 = jointDatas[axis.Jt2Guid];
      if (!joint_1 || !joint_2) {
        continue;
      }

      let itemPtCenter = new THREE.Vector3(joint_1.X, joint_1.Y, 0);
      let itemPt2 = new THREE.Vector3(joint_2.X, joint_2.Y, 0);
      if (Math.abs(itemPtCenter.distanceTo(ptCenter)) > 1) continue; //圆心不同

      let itemRedius = itemPtCenter.distanceTo(itemPt2);
      if (Math.abs(redius - itemRedius) > 1) continue; //半径不同

      return axis;
    }
    return null;
  };

  for (let i_guid = 0; i_guid < floorGuids.length; i_guid++) {
    const floorGuid = floorGuids[i_guid];

    let floorModelData = await getrlStdFlr(floorGuid);
    if (!floorModelData) continue;

    let currAxisDatas = floorModelData["rlAxis"];
    let jointDatas = floorModelData["rlJoint"];
    let gridDataTotal = floorModelData["rlGrid"];
    if (
      !jointDatas ||
      jointDatas.length == 0 ||
      !gridDataTotal ||
      gridDataTotal.length == 0
    ) {
      if (currAxisDatas) {
        //清空画布轴线
        if (store.state.globalData.rl_stdFlr_id == floorGuid) {
          let currShowAxisDatas =
            store.state.rlEntData.totalEntityData["rlAxis"];
          for (let j = 0; j < currShowAxisDatas.length; j++) {
            let entity = currShowAxisDatas[j];
            entity.m_stText?.erase();
            entity.m_edText?.erase();
            entity.m_stLineTmp?.erase();
            entity.m_edLineTmp?.erase();
            entity.m_stCircle?.erase();
            entity.m_edCircle?.erase();
            entity.mcDbId?.getMcDbEntity()?.erase();
          }
          //清空已加载的轴线命名数据
          store.commit("globalData/clearGuidToRlAxisLineLoad");
        }

        //清空轴线数据
        let data = {};
        data["rlAxis"] = [];
        for (const key in currAxisDatas) {
          data["rlAxis"].push(currAxisDatas[key]);
        }

        await delBulkRlStdFlrFieldDatas(floorGuid, data);
      }
      continue;
    }

    //计算所有的共线网格
    let updataDatas = {}; //需要更新的数据
    updataDatas["rlAxis"] = [];
    updataDatas["rlGrid"] = [];
    let collinearGridData = []; //已计算的共线网格
    let gridDataKeys = Object.keys(gridDataTotal);

    for (let i = 0; i < gridDataKeys.length; i++) {
      let gridItem = gridDataTotal[gridDataKeys[i]];
      if (collinearGridData.includes(gridDataKeys[i])) continue;
      collinearGridData.push(gridDataKeys[i]);

      const joint_1 = jointDatas[gridItem.Jt1Guid];
      const joint_2 = jointDatas[gridItem.Jt2Guid];
      if (!joint_1 || !joint_2) {
        continue;
      }
      let itemPt1 = new THREE.Vector3(joint_1.X, joint_1.Y, 0);
      let itemPt2 = new THREE.Vector3(joint_2.X, joint_2.Y, 0);

      let axisPoints = [];
      let updataGrids = []; //需要更新的网格数据--修改关联的轴线数据

      if (gridItem.Jt0Guid) {
        const joint_0 = jointDatas[gridItem.Jt0Guid];
        if (!joint_0) {
          continue;
        }
        let itemPtCenter = new THREE.Vector3(joint_0.X, joint_0.Y, 0);
        let redius = itemPtCenter.distanceTo(itemPt1);
        //计算网格的起点和终点的角度
        const startAngle = toDegrees(calculateArcAngle(itemPtCenter, itemPt1));
        const endAngle = toDegrees(calculateArcAngle(itemPtCenter, itemPt2));
        // axisPoints.push({ angle: startAngle, obj: joint_1, pt: itemPt1 });
        // axisPoints.push({ angle: endAngle, obj: joint_2, pt: itemPt2 });
        axisPoints.push(gridItem.Jt1Guid);
        axisPoints.push(gridItem.Jt2Guid);
        updataGrids.push(gridItem);
        for (let j = 0; j < gridDataKeys.length; j++) {
          if (i == j) continue;
          if (collinearGridData.includes(gridDataKeys[j])) continue;
          let gridItem2 = gridDataTotal[gridDataKeys[j]];
          // 如果第二个网格没有中心点(Jt0Guid)或者两个网格的中心点不同，则跳过当前循环
          // 这里确保只处理具有相同中心点的圆弧网格
          if (!gridItem2.Jt0Guid || gridItem.Jt0Guid !== gridItem2.Jt0Guid)
            continue;

          const joint2_1 = jointDatas[gridItem2.Jt1Guid];
          const joint2_2 = jointDatas[gridItem2.Jt2Guid];
          if (!joint2_1 || !joint2_2) {
            continue;
          }
          let itemPt3 = new THREE.Vector3(joint2_1.X, joint2_1.Y, 0);
          let itemPt4 = new THREE.Vector3(joint2_2.X, joint2_2.Y, 0);

          let redius2 = itemPt3.distanceTo(itemPtCenter);
          if (Math.abs(redius - redius2) > 1) continue;

          //计算网格的起点和终点的角度
          const startAngle2 = toDegrees(
            calculateArcAngle(itemPtCenter, itemPt3)
          );
          const endAngle2 = toDegrees(calculateArcAngle(itemPtCenter, itemPt4));
          // axisPoints.push({ angle: startAngle2, obj: joint2_1, pt: itemPt3 });
          // axisPoints.push({ angle: endAngle2, obj: joint2_2, pt: itemPt4 });
          const index1 = axisPoints.indexOf(gridItem2.Jt1Guid);
          const index2 = axisPoints.indexOf(gridItem2.Jt2Guid);
          if (index1 > -1 && index2 > -1) {
            //不必加入
          } else if (index1 > -1) {
            axisPoints.splice(index1 + 1, 0, gridItem2.Jt2Guid);
          } else if (index2 > -1) {
            axisPoints.splice(index2 + 1, 0, gridItem2.Jt1Guid);
          } else {
            axisPoints.push(gridItem2.Jt1Guid);
            axisPoints.push(gridItem2.Jt2Guid);
          }
          collinearGridData.push(gridItem2.Guid);
          updataGrids.push(gridItem2);
        }
        //对axisPoints进行排序
        // axisPoints.sort((a, b) => {
        //   return normalizeAngle(a.angle) - normalizeAngle(b.angle);
        // });

        let obj = {
          Guid: generate_guid(),
          IsMainAxis: -1,
          IsShow: "1",
          Jt1Guid: joint_0.Guid,
          Jt2Guid: axisPoints[0],
          Name: "",
          No_: 1,
          OtherData: "",
          StdFlrGuid: floorGuid,
        };

        if (currAxisDatas) {
          const jt2Data = jointDatas[axisPoints[0]];
          let objTmp = getEquleArcAxisData(
            currAxisDatas,
            jointDatas,
            itemPtCenter,
            new THREE.Vector3(jt2Data.X, jt2Data.Y, 0)
          );
          if (objTmp) {
            obj = objTmp;
          }
        }

        updataDatas["rlAxis"].push(obj);
        for (let index = 0; index < updataGrids.length; index++) {
          const element = updataGrids[index];
          element.AxisGuid = obj.Guid;
          updataDatas["rlGrid"].push(element);
        }
      } else {
        axisPoints.push({ pt: itemPt1, obj: joint_1 });
        axisPoints.push({ pt: itemPt2, obj: joint_2 });
        updataGrids.push(gridItem);
        for (let j = 0; j < gridDataKeys.length; j++) {
          if (i == j) continue;
          if (collinearGridData.includes(gridDataKeys[j])) continue;

          let gridItem2 = gridDataTotal[gridDataKeys[j]];
          if (gridItem2.Jt0Guid) continue;

          const joint2_1 = jointDatas[gridItem2.Jt1Guid];
          const joint2_2 = jointDatas[gridItem2.Jt2Guid];
          if (!joint2_1 || !joint2_2) {
            continue;
          }

          let itemPt3 = new THREE.Vector3(joint2_1.X, joint2_1.Y, 0);
          let itemPt4 = new THREE.Vector3(joint2_2.X, joint2_2.Y, 0);
          if (areLineCollinear(itemPt1, itemPt2, itemPt3, itemPt4)) {
            collinearGridData.push(gridItem2.Guid);
            axisPoints.push({ pt: itemPt3, obj: joint2_1 });
            axisPoints.push({ pt: itemPt4, obj: joint2_2 });
            updataGrids.push(gridItem2);
          }
        }
        //对axisPoints进行排序
        axisPoints.sort((a, b) => {
          if (Math.abs(a.pt.x - b.pt.x) < 1) {
            return a.pt.y - b.pt.y;
          }
          return a.pt.x - b.pt.x;
        });

        let obj = {
          Guid: generate_guid(),
          IsMainAxis: 0,
          IsShow: "1",
          Jt1Guid: axisPoints[0].obj.Guid,
          Jt2Guid: axisPoints[axisPoints.length - 1].obj.Guid,
          Name: "",
          No_: 1,
          OtherData: "",
          StdFlrGuid: floorGuid,
        };

        if (currAxisDatas) {
          let objTmp = getEquleAxisData(
            currAxisDatas,
            jointDatas,
            axisPoints[0].pt,
            axisPoints[axisPoints.length - 1].pt
          );
          if (objTmp) {
            let points = [
              jointDatas[objTmp.Jt1Guid],
              jointDatas[objTmp.Jt2Guid],
              axisPoints[0].obj,
              axisPoints[axisPoints.length - 1].obj,
            ];
            points.sort((a, b) => {
              return a.X - b.X || a.Y - b.Y;
            });
            objTmp.Jt1Guid = points[0].Guid;
            objTmp.Jt2Guid = points[3].Guid;
            obj = objTmp;
          }
        }
        updataDatas["rlAxis"].push(obj);

        for (let index = 0; index < updataGrids.length; index++) {
          const element = updataGrids[index];
          element.AxisGuid = obj.Guid;
          updataDatas["rlGrid"].push(element);
        }
      }
    }
    //清空数据库中当前楼层的原有所有轴线
    if (floorModelData && currAxisDatas) {
      let data = {};
      data["rlAxis"] = [];
      for (const key in currAxisDatas) {
        data["rlAxis"].push(currAxisDatas[key]);
      }

      await delBulkRlStdFlrFieldDatas(floorGuid, data);
    }

    await updateBulkRlStdFlrFieldDatas(floorGuid, updataDatas);
  }
  iUpdateAxisTimer = Date.now();
};

//更新当前网格所在的轴线数据
export const getGridAxisData = async (gridData) => {
  if (!gridData) return null;

  //获取与当前网格共线的所有网格
  let gridDataTotal = store.state.rlEntData.totalEntityData["rlGrid"];
  if (!gridDataTotal || gridDataTotal.length == 0) return null;

  let gridPt1 = new THREE.Vector3(...gridData.m_stJoint.m_pt);
  let gridPt2 = new THREE.Vector3(...gridData.m_edJoint.m_pt);
  let axisPoints = [];

  if (gridData.m_centerJoint) {
    const centerPt = new THREE.Vector3(...gridData.m_centerJoint.m_pt);
    let redius = centerPt.distanceTo(gridPt1);
    const startAngle = toDegrees(calculateArcAngle(centerPt, gridPt1));
    const endAngle = toDegrees(calculateArcAngle(centerPt, gridPt2));
    // axisPoints.push({ angle: startAngle, obj: gridData.m_stJoint });
    // axisPoints.push({ angle: endAngle, obj: gridData.m_edJoint });
    axisPoints.push({ guid: gridData.m_stJoint.Guid, obj: gridData.m_stJoint });
    axisPoints.push({ guid: gridData.m_edJoint.Guid, obj: gridData.m_edJoint });
    for (let i = 0; i < gridDataTotal.length; i++) {
      let gridItem = gridDataTotal[i];

      if (gridItem.Guid == gridData.Guid) continue;
      if (
        !gridItem.m_centerJoint ||
        gridData.m_centerJoint.Guid !== gridItem.m_centerJoint.Guid
      ) {
        continue;
      }
      let itemPt1 = new THREE.Vector3(...gridItem.m_stJoint.m_pt);
      let itemPt2 = new THREE.Vector3(...gridItem.m_edJoint.m_pt);
      let redius2 = centerPt.distanceTo(itemPt1);
      if (Math.abs(redius - redius2) > 1) continue;
      const startAngle2 = toDegrees(calculateArcAngle(centerPt, itemPt1));
      const endAngle2 = toDegrees(calculateArcAngle(centerPt, itemPt2));
      // axisPoints.push({ angle: startAngle2, obj: gridItem.m_stJoint });
      // axisPoints.push({ angle: endAngle2, obj: gridItem.m_edJoint });
      const index1 = axisPoints.findIndex(
        (item) => item.guid === gridItem.m_stJoint.Guid
      );
      const index2 = axisPoints.findIndex(
        (item) => item.guid === gridItem.m_edJoint.Guid
      );
      if (index1 > -1 && index2 > -1) {
        //不必加入
      } else if (index1 > -1) {
        axisPoints.splice(index1 + 1, 0, {
          guid: gridItem.m_stJoint.Guid,
          obj: gridItem.m_stJoint,
        });
      } else if (index2 > -1) {
        axisPoints.splice(index2 + 1, 0, {
          guid: gridItem.m_edJoint.Guid,
          obj: gridItem.m_edJoint,
        });
      } else {
        axisPoints.push({
          guid: gridItem.m_stJoint.Guid,
          obj: gridItem.m_stJoint,
        });
        axisPoints.push({
          guid: gridItem.m_edJoint.Guid,
          obj: gridItem.m_edJoint,
        });
      }
    }

    // axisPoints.sort((a, b) => {
    //   return a.angle - b.angle;
    // });
    let axisData = new rlAxisArcData();
    axisData.initData({
      m_stJoint: gridData.m_centerJoint,
      m_edJoint: axisPoints[0].obj,
      IsMainAxis: -1,
      Name: "",
      StdFlrGuid: gridData.StdFlrGuid,
      m_stArcPoint: axisPoints[0].obj.m_pt,
      m_edArcPoint: axisPoints[axisPoints.length - 1].obj.m_pt,
    });

    await addEntityToDrawing(axisData, false);

    return axisData;
  } else {
    axisPoints.push({ pt: gridPt1, obj: gridData.m_stJoint });
    axisPoints.push({ pt: gridPt2, obj: gridData.m_edJoint });
    for (let i = 0; i < gridDataTotal.length; i++) {
      let gridItem = gridDataTotal[i];
      if (gridItem.Guid == gridData.Guid) continue;
      let itemPt1 = new THREE.Vector3(...gridItem.m_stJoint.m_pt);
      let itemPt2 = new THREE.Vector3(...gridItem.m_edJoint.m_pt);
      if (itemPt1.equals(itemPt2)) continue;

      if (areLineCollinear(itemPt1, itemPt2, gridPt1, gridPt2)) {
        axisPoints.push({ pt: itemPt1, obj: gridItem.m_stJoint });
        axisPoints.push({ pt: itemPt2, obj: gridItem.m_edJoint });
      }
    }
    //对axisPoints进行排序
    // 计算排序方向向量
    const direction = new THREE.Vector3()
      .subVectors(gridPt2, gridPt1)
      .normalize();
    // 使用投影排序，确保沿着轴线方向正确排序
    axisPoints.sort((a, b) => {
      // 计算点到起点的向量
      const vecA = new THREE.Vector3().subVectors(a.pt, gridPt1);
      const vecB = new THREE.Vector3().subVectors(b.pt, gridPt1);
      // 计算在方向向量上的投影距离
      const projA = vecA.dot(direction);
      const projB = vecB.dot(direction);
      // 按投影距离排序
      return projA - projB;
    });

    let axisData = new rlAxisData();
    axisData.initData({
      m_stJoint: axisPoints[0].obj,
      m_edJoint: axisPoints[axisPoints.length - 1].obj,
      IsMainAxis: 0,
      Name: "",
      StdFlrGuid: gridData.StdFlrGuid,
    });

    await addEntityToDrawing(axisData, false);

    return axisData;
  }
};

//更新当前画布的轴线命名显示数据
export const updataAxisShowData = async () => {
  //清空画布轴线
  let currShowAxisDatas = store.state.rlEntData.totalEntityData["rlAxis"];
  for (let j = 0; j < currShowAxisDatas.length; j++) {
    let entity = currShowAxisDatas[j];
    entity.m_stText?.erase();
    entity.m_edText?.erase();
    entity.m_stLineTmp?.erase();
    entity.m_edLineTmp?.erase();
    entity.m_stCircle?.erase();
    entity.m_edCircle?.erase();
    entity.mcDbId?.getMcDbEntity()?.erase();
  }
  store.commit("rlEntData/clearAnyClassData", "rlAxis");
  //清空已加载的轴线命名数据
  store.commit("globalData/clearGuidToRlAxisLineLoad");
  //更新数据库数据
  await updateAxisData(false);

  //更新轴线数据画布绘制
  let floorModelData = await getrlStdFlr(store.state.globalData.rl_stdFlr_id);
  if (!floorModelData || !floorModelData["rlAxis"]) {
    return;
  }
  let axisData = floorModelData["rlAxis"];
  let gridData = floorModelData["rlGrid"];

  let guids = Object.keys(axisData);
  let index = 0;
  let batchSize = 100; // 批次处理大小
  return new Promise((resolve) => {
    function processBatch() {
      let promises = [];
      let end = Math.min(index + batchSize, guids.length);

      for (; index < end; index++) {
        let guid = guids[index];
        let dataObj = axisData[guid];

        if (!dataObj) continue;

        let jt1 = getEntityData({
          Guid: dataObj.Jt1Guid,
          classTypeName: "rlJoint",
        });
        let jt2 = getEntityData({
          Guid: dataObj.Jt2Guid,
          classTypeName: "rlJoint",
        });

        let gridObj = Object.values(gridData).filter(
          (item) => item.AxisGuid == guid
        );

        if (jt1 && jt2) {
          let rlAxisObj = null;
          if (dataObj.IsMainAxis < 0 && gridObj) {
            if (gridObj && gridObj.length) {
              let centerPt = new THREE.Vector3(...jt1.m_pt);
              let axisPoints = [];
              for (let index = 0; index < gridObj.length; index++) {
                const obj = getEntityData({
                  Guid: gridObj[index].Guid,
                  classTypeName: "rlGrid",
                });
                if (!obj) continue;
                let itemPt1 = new THREE.Vector3(...obj.m_stJoint.m_pt);
                let itemPt2 = new THREE.Vector3(...obj.m_edJoint.m_pt);
                const startAngle = toDegrees(
                  calculateArcAngle(centerPt, itemPt1)
                );
                const endAngle = toDegrees(
                  calculateArcAngle(centerPt, itemPt2)
                );
                // ptAngleDatas.push({
                //   angle: startAngle,
                //   pt: obj.m_stJoint.m_pt,
                // });
                // ptAngleDatas.push({ angle: endAngle, pt: obj.m_edJoint.m_pt });
                if (axisPoints.length == 0) {
                  axisPoints.push({
                    guid: obj.m_stJoint.Guid,
                    pt: obj.m_stJoint.m_pt,
                  });
                  axisPoints.push({
                    guid: obj.m_edJoint.Guid,
                    pt: obj.m_edJoint.m_pt,
                  });
                } else {
                  const index1 = axisPoints.findIndex(
                    (item) => item.guid === obj.m_stJoint.Guid
                  );
                  const index2 = axisPoints.findIndex(
                    (item) => item.guid === obj.m_edJoint.Guid
                  );
                  if (index1 > -1 && index2 > -1) {
                    //不必加入
                  } else if (index1 > -1) {
                    axisPoints.splice(index1 + 1, 0, {
                      guid: obj.m_edJoint.Guid,
                      pt: obj.m_edJoint.m_pt,
                    });
                  } else if (index2 > -1) {
                    axisPoints.splice(index2 + 1, 0, {
                      guid: obj.m_stJoint.Guid,
                      pt: obj.m_stJoint.m_pt,
                    });
                  } else {
                    axisPoints.push({
                      guid: obj.m_stJoint.Guid,
                      pt: obj.m_stJoint.m_pt,
                    });
                    axisPoints.push({
                      guid: obj.m_edJoint.Guid,
                      pt: obj.m_edJoint.m_pt,
                    });
                  }
                }
              }
              // ptAngleDatas.sort((a, b) => {
              //   return a.angle - b.angle;
              // });
              // console.log("axisPoints", axisPoints);

              rlAxisObj = new rlAxisArcData();
              rlAxisObj.initData({
                m_stJoint: jt1,
                m_edJoint: jt2,
                m_stArcPoint: axisPoints[0].pt,
                m_edArcPoint: axisPoints[axisPoints.length - 1].pt,
                IsMainAxis: dataObj.IsMainAxis,
                Name: dataObj.Name,
                Guid: dataObj.Guid,
                StdFlrGuid: dataObj.StdFlrGuid,
                isShow: dataObj.IsShow,
              });
            }
          } else {
            rlAxisObj = new rlAxisData();
            rlAxisObj.initData({
              m_stJoint: jt1,
              m_edJoint: jt2,
              IsMainAxis: dataObj.IsMainAxis,
              Name: dataObj.Name,
              Guid: dataObj.Guid,
              StdFlrGuid: dataObj.StdFlrGuid,
              isShow: dataObj.IsShow,
            });
          }
          if (rlAxisObj) {
            // 并行执行绘制操作
            promises.push(addEntityToDrawing(rlAxisObj, true));
          }
        }
      }

      // 等待当前批次的绘制操作完成
      Promise.all(promises).then(() => {
        if (index < guids.length) {
          // 继续处理下一批数据
          queueMicrotask(processBatch);
        } else {
          // 所有批次完成，返回最终结果
          resolve();
        }
      });
    }

    processBatch();
  });
};
